import React from "react";
import ChartGraph from "../components/ChartGraph";
import Nav from "../components/Nav";

function ChartPage() {
  return (
    <>
      <Nav />
      <ChartGraph />
    </>
  );
}

export default ChartPage;
